<template>
  <div v-if="isOpen">
    <b-modal
      centered
      title="Discount Option Used"
      v-model="isOpen"
      id="modal-xl"
      size="lg"
      hide-footer
      @hide="cancel"
    >
      <b-card class="mt-1">
        <validation-observer ref="createForm" v-slot="{ handleSubmit }" class="mr-4 ml-4">
          <b-form @submit.stop.prevent="handleSubmit()">
            <validation-provider
              name=""
              v-slot="validationContext"
              :rules="{ required: true }"
            >
              <b-form-group label="Discount option used" label-for="h-public-date" label-cols-md="5">
                <b-form-input v-model="model.value" class="border" />
                <b-form-invalid-feedback id="h-public-date">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-form>
        </validation-observer>
      </b-card>
      <div class="d-flex justify-content-between my-2">
        <b-button variant="danger" @click="cancel">Cancel</b-button>
        <b-button :disabled="!!isLoading" type="submit" variant="primary" @click="onSave">
          <b-spinner v-if="isLoading" class="mr-1" small />
          <span>Save</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import service from "../../service";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      isOpen: false,
      isUpdate: false,
      isLoading: false,
      model: {},
    };
  },

  async created() {
    await this.getDiscountOptionUsedConfig()
  },

  methods: {
    async getDiscountOptionUsedConfig() {
      this.model = await service.getDiscountOptionUsedConfig()
    },

    async openCreateModal() {
      this.model = {}
      this.isOpen = true;
      this.isUpdate = false;
    },

    async openUpdateModal() {
      await this.getDiscountOptionUsedConfig()
      this.isOpen = true;
      this.isUpdate = true;
    },

    async onSave() {
      let validation = await this.$refs.createForm.validate();
      if (validation) {
        this.isOpen = true;
        this.isLoading = true;
        if (this.isUpdate) {
          try {
            await service.updateDiscountOptionUsedConfig(this.model);
          } catch (e) {
            this.isLoading = false;
          }
        }
        this.isLoading = false;
        this.isOpen = false;
        this.getDiscountOptionUsedConfig()
      }
    },

    cancel() {
      this.isOpen = false;
      this.isUpdate = false;
    },

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
<style lang="scss" scoped>
label {
  font-size: 16px;
  margin-top: 0.3rem;
  margin-bottom: 0;
}
</style>
